export class SmeltingEnergyCost {
    constructor({
          id= null, 
          planCode= ``, 
          day= ``,
          locName= ``,          
          shift='',
          furnaceName= ``, 
          furnaceBatch= ``, 
          energyName= ``,
          energyCode= ``,         
          energyCost= ``,
          unit= ``,
          
      } = {}) {
      this.id = id;
      this.planCode = planCode;
      this.day = day;
      this.locName = locName;     
      this.shift = shift; 
      this.furnaceName = furnaceName;
      this.furnaceBatch = furnaceBatch; 
      this.energyName = energyName;
      this.energyCode = energyCode;
      this.energyCost = energyCost;
      this.unit = unit;     
    }
  }
  export function gridFields() {
    return Object.freeze([         
        {
          key: 'planCode',
          label: 'lbl.basic.planCode',
          sortable: true,
          form: {
            type: 'input'
          }
        }, 
        {
          key: 'locName',
          label: 'lbl.basic.locName',
          sortable: true,
          form: {
            type: 'input'
          }
        },  
        {
          key: 'day',
          label: 'lbl.basic.day',
          sortable: true,
          form: {
            type: 'datepicker'
          }
        },   
        {
          key: 'shift',
          label: 'lbl.basic.shift',
          sortable: true,
          form: {
            type: 'input'
          }
        }, 
        // {
        //   key: 'furnaceName',
        //   label: 'lbl.basic.furnaceName',
        //   sortable: true,
        //   form: {
        //     type: 'select',
        //     options: [
        //       {value:"default", text:"lbl.basic.select.one"},
        //       {value:"1", text:"opt.furnaceNumber1"},
        //       {value:"2", text:"opt.furnaceNumber2"},
        //       {value:"3", text:"opt.furnaceNumber3"},
        //       {value:"4", text:"opt.furnaceNumber4"},
        //       {value:"5", text:"opt.furnaceNumber5"},
        //       {value:"6", text:"opt.furnaceNumber6"},
        //     ]
        //   }
        // },
        // {
        //   key: 'furnaceBatch',
        //   label: 'lbl.basic.furnaceBatch',
        //   sortable: true,
        //   form: {
        //     type: 'input'
        //   }          
        // },                      
        {
          key: 'energyName',
          label: 'lbl.basic.energyName',
          sortable: false,
          form: {
            type: 'input'
          }
        }, 
        {
          key: 'energyCode',
          label: 'lbl.basic.energyCode',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'energyCost',
          label: 'lbl.prd.execution.energyCost',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'unit',
          label: 'lbl.basic.unit',
          sortable: false,
          form: {
            type: 'input'
          }
        }
    ]);
  }
  export const fields = Object.freeze(Object.keys(new SmeltingEnergyCost()).map(i => 'entity.' + i));
  export const filterFields = [
    'filter.planCodeFilter',
    'filter.plantFilter',
    'filter.shiftFilter',
    'filter.startDayFilter',
    'filter.endDayFilter', 
    'filter.energyFilter',
    'filter.furnaceName',     
  ];
  export const filter = {
    'planCodeFilter': "", 
    'plantFilter': "",
    'shiftFilter': "",
    'startDayFilter': "",
    'endDayFilter': "",
    'energyFilter': "",
    'furnaceNameFilter': "",
  };